// extracted by mini-css-extract-plugin
export default {"container":"order_container__CZp7F"};